// import Header from "./components/Header";
// import Banner from "./components/Banner";
// // import Projects from "./components/Project";
// import Calender from "./components/Calender";
// import Stats from "./components/stats";
// import Contact from "./components/ContactMe";
// import Skills from "./components/Skills";
// import Project from "./components/projects";
// import Aboutme from "./components/Aboutme";
import AllRoute from "./All_Routes/AllRoute";

function App() {
  return (
    <div>
      {/* <Header />

      <Banner />
      <Aboutme />

      <Skills />
      <Project />

      <Calender />
      <Stats />

      <Contact /> */}
      <link
        rel="icon"
        href="https://img.freepik.com/free-vector/human-hand-typing-computer-with-different-symbols-located-near-cup-coffee-side-view-open-laptop-flat-vector-illustration-new-technologies-millennials-work-concept_74855-21931.jpg?w=2000"
      />
      <AllRoute />
    </div>
  );
}

export default App;
